export default "__VITE_ASSET__DR5CxqLr__"